export default function generateDates(year, month){
  const array = [];
  const now = new Date(year, month);
  let date;

  for(var i = 0; i < 12; i++) {
    date = new Date(now.getFullYear(), now.getMonth()+i, 1);
    array.push(date);
  }
  return array;
}